"use client";

import { useTranslations } from "next-intl";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { motion } from "framer-motion";

export const HeroSection = () => {
  const t = useTranslations("hero");

  // Variants pour les animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const titleVariants = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const subtitleVariants = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const buttonVariants = {
    hidden: {
      opacity: 0,
      y: 20,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  // Diviser le titre pour gérer le saut de ligne
  const titleParts = t("title").split("\n");

  return (
    <motion.section
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="mt-20 flex flex-col items-center justify-center gap-6 py-20 pb-0 lg:gap-8"
    >
      <motion.h1
        variants={titleVariants}
        className="text-center font-sentient text-xl font-medium text-secondary xs:text-2xl ph:text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl"
      >
        {titleParts.map((part, index) => (
          <span key={index}>
            {part}
            {index < titleParts.length - 1 && <br />}
          </span>
        ))}
      </motion.h1>

      <motion.p
        variants={subtitleVariants}
        className="text-md text-center text-accent lg:text-lg"
      >
        {t("subtitle")}
      </motion.p>

      <motion.div variants={buttonVariants}>
        <PrimaryButton
          navigateTo="https://calendly.com/agence-virtuosa/appel-decouverte"
          target="_blank"
        />
      </motion.div>
    </motion.section>
  );
};
